require './account'
require '../transforms/mixed'

LONG_AGO_CONNECTION_INTERVAL = 10  # В минутах
LOST_CONNECTION_INTERVAL     = 45  # В минутах

###
# Модель курьера
###
App.Courier = App.Account.extend
  outsourced  : DS.attr 'boolean'
  comment: DS.attr 'string'

  disabled:     DS.attr 'boolean'
  is_running:   DS.attr 'boolean'

  restaurants:  DS.hasMany   'restaurant',   async: true
  avatar:  DS.attr 'mixed'

  status:  DS.attr 'string'

  transport_type: DS.attr 'string'

  last_known_position: DS.attr 'coordinates'
  lastKnownPositionAt: DS.attr 'date'
  # currentOrderData: DS.attr 'mixed'

  # Внешние связи
  current_order_id: DS.attr 'number'
  organization: DS.belongsTo 'organization', async: true
  partnership:  DS.belongsTo 'partnership',  async: true
  logistics_center: DS.belongsTo 'logistics_center', async: true

  selectedTransportType: (->
    @get('courierTypes').find (type) => type.id == @get('transport_type')
  ).property('transport_type')

  restaurants_names: Ember.computed 'restaurants', ->
    if @get('restaurants.length') == 0
      return Em.I18n.t 'courier.availability_everywhere'

    @get('restaurants').map((e) -> e.get('name')).join(', ')

  longAgoConnection: Ember.computed 'lastKnownPositionAt', ->
    lastTime = @get 'lastKnownPositionAt'

    if Ember.isEmpty(lastTime) then return null

    now = moment()
    lastTime = moment(lastTime)
    duration = moment.duration(now.diff(lastTime));

    duration.asMinutes() >= LONG_AGO_CONNECTION_INTERVAL

  avatarUrl: ( ->
    return "images/map-markers/courier-marker-clean-#{@get('status')}.svg"

    avatar = @get('avatar.small')
    avatar = "images/map-markers/courier-marker-clean.png" unless avatar

    avatar += "?avatar-icon=true&status=status-#{@get('status')}"

    avatar
  ).property('avatar','status')

  currentOrder: ( ->
    id = @get('current_order_id')
    unless id
      return new Em.RSVP.Promise (resolve, reject) =>
        resolve()

    @store.find('order', id)


  ).property('current_order_id')

  lostConnection: Ember.computed 'lastKnownPositionAt', ->
    lastTime = @get 'lastKnownPositionAt'

    if Ember.isEmpty(lastTime) then return null

    now = moment()
    lastTime = moment(lastTime)
    duration = moment.duration(now.diff(lastTime));

    duration.asMinutes() >= LOST_CONNECTION_INTERVAL


  courierTypes: (->
    ['public_transport', 'walk', 'car'].map (type) => {
      id: type,
      translation: Em.I18n.t "courier.edit.transport_type.types.#{type}"
    }
  ).property()

  selectedTransportTypeObserver: (->
    @set('transport_type', @get('selectedTransportType.id'))
  ).observes('selectedTransportType')


  # Картографические свойства
  lat: Ember.computed.alias 'last_known_position.lat'
  lng: Ember.computed.alias 'last_known_position.lon'
  markerIcon: L.icon
    iconUrl: '/images/map-markers/courier-marker-round.png'
    iconSize: [52, 52]
    iconAnchor: [26, 26]
    popupAnchor: [0, -26]
  isReadyToDrawOnMap: Ember.computed.and 'lat', 'lng'

  getStatus: (order_id)->
    @set('loadingStatus', true)
    @nonRESTAction('GET', 'status', {order_id: order_id})
    .then (data) =>
      @set('statusData', data)
      @set('loadingStatus', false)
